module.exports = __webpack_public_path__ + "07cdc300e9e30af24f13c7f9d2a0957c.fbx";